import { Modal, Title, Text, Button, Stack, Box } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { primaryColor } from '../../constants/theme';

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message: string;
}

export const SuccessModal = ({
  open,
  onClose,
  title = 'Success',
  message,
}: SuccessModalProps) => {
  return (
    <Modal opened={open} onClose={onClose} centered padding="xl">
      <Stack justify="center" align="center" gap="xl">
        <Box
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${primaryColor} 0%, #00a878 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 24px rgba(0, 202, 153, 0.3)',
          }}
        >
          <IconCheck size={48} color="white" stroke={3} />
        </Box>
        <Title order={2} fw={600} ta="center">
          {title}
        </Title>
        <Text size="lg" ta="center" c="dimmed" px="md">
          {message}
        </Text>
        <Button
          color={primaryColor}
          size="lg"
          w="100%"
          onClick={onClose}
          radius="md"
          style={{ marginTop: 8 }}
        >
          OK
        </Button>
      </Stack>
    </Modal>
  );
};
